import { LazyAction, LazyModule } from 'owa-bundling-light';

const lazyModule = new LazyModule(
    () => import(/* webpackChunkName: "OwaDataWorkerClient" */ './lazyIndex')
);

export const lazyExecuteRequest = new LazyAction(lazyModule, m => m.executeRequest);
export const lazyUnsubscribe = new LazyAction(lazyModule, m => m.unsubscribe);
export const lazyOnHierarchyNotification = new LazyAction(
    lazyModule,
    m => m.onHierarchyNotification
);
export const lazySetDisableAllRequests = new LazyAction(lazyModule, m => m.setDisableAllRequests);

export { stashSessionData } from './actions/sessionDataStash';
